export const TABS = {
  OFFER_DETAILS: 'OfferDetails',
  INITIALIZE: 'Initialize',
  REFINE: 'Refine',
  FINALIZE: 'Finalize',
  FINALIZE_SP: 'FinalizeSocialPay',
};



// WEBPACK FOOTER //
// ./src/payments/constants/SettingsConstants.js